// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"81":"6cb7db04","126":"d3e47f67","232":"ad840fe5","692":"1e7b84a0","698":"4f643681","744":"5abaa50b","746":"2c8aedc2","802":"22aab5b2","868":"2782ea02","899":"854935fb","931":"d9ee70f8"}[chunkId] + ".js";
};